<template>
	<ScopedColorTheme tag="header" theme="red" class="c-frontpage-header">
		<div
			class="
				c-frontpage-header__main
				relative
				px-layout-margin
				text-white
			"
			:class="{
				'pt-site-header':
					(spot && !spot.image) ||
					(!spot && (!spotFallback || !spotFallback.image)),
			}"
		>
			<HeaderGraphic
				v-if="headerGraphic > -2"
				class="c-frontpage-header__header-graphic justify-start"
				style="z-index: -1"
				:index="headerGraphic"
			/>
			<LinkTile
				v-if="spot"
				:component="typeof spot.url === 'string' ? 'LinkTile' : 'div'"
				:to="spot.url"
				class="group flex flex-col pointer-events-none h-max"
				:class="{
					'>=1024:grid-cols-1 items-start': !spot.image,
					'>=1024:grid >=1024:grid-cols-2 >=1024:items-end':
						spot.image,
				}"
				:aria-labelledby="
					spot.title || spot.name
						? 'c-frontpage-header__spot-title'
						: 'c-frontpage-header__spot-link'
				"
				:custom-link-attrs="{
					'data-focus': '#c-frontpage-header__spot-link',
				}"
			>
				<!-- Content -->
				<div
					class="
						pt-2xs/v
						order-1
						>=1024:order-none >=1024:pt-2xl/v
						pb-md/v
						>=1024:pb-2xl/h
						pr-(1/2)/12col
						>=1024:pr-(1/2)/12col
						flex flex-col
						items-start
					"
				>
					<div
						id="c-frontpage-header__spot-link"
						class="pointer-events-auto"
					>
						<small
							v-if="spot.label"
							class="
								w-full
								flex
								items-center
								mb-lg/v
								test-label-sm
							"
						>
							<span
								class="uppercase font-medium"
								v-text="spot.label"
							></span>
						</small>

						<BaseH1
							v-if="spot.title || spot.name"
							id="c-frontpage-header__spot-title"
							class="text-h1-frontpage font-bold"
							v-html="spot.title || spot.name"
						>
						</BaseH1>
					</div>
					<SvgIconGt class="c-frontpage-header__link-indicator" />
				</div>
				<BaseImg
					v-if="spot.image"
					:src="spot.image.cropUrl || spot.image.url"
					:alt="spot.image.altText"
					class="
						c-frontpage-header__spot-image
						pointer-events-auto
						self-stretch
						overflow-hidden
					"
					:width="spot.image.width"
					:height="spot.image.height"
					:img-attrs="{
						fetchpriority: 'high',
						class: 'object-cover transition-all duration-500 ease-in-out',
					}"
				/>
			</LinkTile>

			<div
				v-if="!spot && spotFallback"
				class="group flex flex-col pointer-events-none h-max"
				:class="{
					'>=1024:grid-cols-1 items-start': !spotFallback.image,
					'>=1024:grid >=1024:grid-cols-2 >=1024:items-end':
						spotFallback.image,
				}"
				:aria-labelledby="
					spotFallback.title || spotFallback.name
						? 'c-frontpage-header__spot-title'
						: 'c-frontpage-header__spot-link'
				"
				:custom-link-attrs="{
					'data-focus': '#c-frontpage-header__spot-link',
				}"
			>
				<!-- Content -->
				<div
					class="
						pt-2xs/v
						order-1
						>=1024:order-none >=1024:pt-2xl/v
						pb-md/v
						>=1024:pb-2xl/h
						pr-(1/2)/12col
						>=1024:pr-(1/2)/12col
						flex flex-col
						items-start
					"
				>
					<div
						id="c-frontpage-header__spot-link"
						class="pointer-events-auto"
					>
						<small
							v-if="spotFallback.label"
							class="
								w-full
								flex
								items-center
								mb-lg/v
								test-label-sm
							"
						>
							<span
								class="uppercase font-medium"
								v-text="spotFallback.label"
							></span>
						</small>

						<BaseH1
							v-if="spotFallback.title || spotFallback.name"
							id="c-frontpage-header__spot-title"
							class="text-h1-frontpage font-bold"
							v-html="spotFallback.title || spotFallback.name"
						>
						</BaseH1>
					</div>
					<SvgIconGt class="c-frontpage-header__link-indicator" />
				</div>
				<BaseImg
					v-if="spotFallback.image"
					:src="spotFallback.image.cropUrl || spotFallback.image.url"
					:alt="spotFallback.image.altText"
					class="
						c-frontpage-header__spot-image
						pointer-events-auto
						self-stretch
						overflow-hidden
					"
					:width="spotFallback.image.width"
					:height="spotFallback.image.height"
					:img-attrs="{
						fetchpriority: 'high',
						class: 'object-cover transition-all duration-500 ease-in-out',
					}"
				/>
			</div>
		</div>
	</ScopedColorTheme>
</template>

<script>
import ScopedColorTheme from '~/components/main/ScopedColorTheme';
import HeaderGraphic from '~/components/main/HeaderGraphic';
import LinkTile from '~/components/shared/LinkTile';
import { nuxtImgSizes } from '~/assets/js/utilities/helpers';
import SvgIconGt from '~/assets/svgs/icon-gt.svg?inline';

export default {
	name: 'FrontpageHeader',

	components: {
		ScopedColorTheme,
		HeaderGraphic,
		LinkTile,
		SvgIconGt,
	},

	props: {
		intro: Object,
		spot: Object,
		spotFallback: Object,
		headerGraphic: {
			type: Number,
			default: 2,
		},
	},

	methods: {
		nuxtImgSizes,
	},
};
</script>

<style lang="postcss">
.c-frontpage-header__main:before {
	@apply absolute bg-theme;
	content: '';
	left: calc(var(--margin, 0px) * -1);
	top: 0;
	width: calc(100% + var(--margin, 0px) * 2);
	height: 100%;
	z-index: -1;
}
.c-frontpage-header__header-graphic {
	@apply absolute bottom-0  block;
	z-index: -1;
	max-height: 100%;
	min-height: 50%;
	left: calc(var(--theme-layout-margin) * -1);
	@screen >=1441 {
		left: calc(
			(100vw - var(--theme-layout-max, 1440px)) / -2 +
				var(--theme-layout-margin) * -1
		);
	}
}

.c-frontpage-header__header-graphic.c-header-graphic {
	width: 100vw;
}

@screen >=1441 {
	.c-frontpage-header__main {
		--margin: (
				var(--visual-viewport-width, 100vw) -
					var(--theme-layout-max, 1440px)
			) / 2;
	}
}

.c-link-tile[data-hover='hover'] {
	.c-frontpage-header__spot-image img {
		object-position: 49% 50%;
	}
	.c-frontpage-header__link-indicator {
		translate: 0;
		opacity: 1;
	}
}
.c-frontpage-header__spot-image {
	width: 100vw;
	max-height: 60vh;
	aspect-ratio: 0.8 !important;
	left: calc(var(--theme-layout-margin) * -1);
	position: relative;

	@screen >=1024 {
		width: 50vw;
		max-height: 900px;
		height: 100vh;
		left: auto;
	}
	@screen >=1441 {
		margin-right: (
				var(--visual-viewport-width, 100vw) -
					var(--theme-layout-max, 1440px)
			) / 2;
	}
}

.c-frontpage-header__link-indicator {
	@apply relative left-auto mt-md/h;
	width: 38px;
	height: 38px;
	margin-bottom: 7px;
	translate: -16px 0;
	opacity: 0;
	left: auto;
	transition: opacity 0.3s, translate 0.3s cubic-bezier(0.47, 0, 0.745, 0.715);
}

@screen print {
	.c-frontpage-header,
	.c-frontpage-header__main > * {
		@apply text-text;
	}
	.c-frontpage-header__main {
		@apply contents;

		&:before {
			@apply hidden;
		}
	}
	.c-frontpage-header__header-graphic {
		@apply hidden;
	}
}
</style>
